// ** Initial State
const initialState = {
    allData: [],
    selectedUserPermission: null,
    errors: false
  }
  
  const monthlyFinancialReports = (state = initialState, action) => {
    switch (action.type) {
      case 'GET_ALL_PERMISSIONS':
        return { ...state, allData: action.data }
      case 'GET_PERMISSION_USER':
          return { ...state, selectedUserPermission: action.data }
      case 'SET_PERMISSION_USER':
            return { ...state, selectedUserPermission: action.selectedUserPermission, error: action.errors }
      default:
        return { ...state }
    }
  }
  export default monthlyFinancialReports